import { useBreakPoints } from '@/hooks/use-break-points';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { withLayoutContext } from 'expo-router';
import { Dimensions, Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

const { Navigator } = createMaterialTopTabNavigator();

const MaterialTopTabs = withLayoutContext(Navigator);

const PersonaMaterialTopTabsLayout = () => {
  const { isMobile } = useBreakPoints();
  return (
    <SafeAreaView
      edges={
        Platform.OS === 'ios'
          ? ['top', 'left', 'right']
          : // for Android to remove gap at top
            ['left', 'right']
      }
      className="ios:mt-[90px] flex-1"
    >
      <MaterialTopTabs
        initialRouteName="index"
        initialLayout={{
          width: Dimensions.get('window').width
        }}
        screenOptions={{
          swipeEnabled: isMobile,
          lazy: true
        }}
      >
        <MaterialTopTabs.Screen
          name="index"
          options={{
            title: 'Active'
          }}
        />
        <MaterialTopTabs.Screen
          name="inactive"
          options={{
            title: 'Archive'
          }}
        />
      </MaterialTopTabs>
    </SafeAreaView>
  );
};

export default PersonaMaterialTopTabsLayout;
